<template>
  <el-dialog
    :title="`${model.id ? '编辑使用记录' : '添加使用记录'}`"
    :visible.sync="visible"
    width="750px"
    @close="$emit('update:show', false)"
  >
    <el-form
      ref="form"
      size="small"
      label-width="120px"
      :rules="rules"
      :model="model"
      class="fix-width"
      inline
    >
      <el-form-item
        :label="model.id && !model.product_group_id ? '仪器' : '仪器串'"
        prop="product_group_id"
        :class="{ long: model.id }"
      >
        <template v-if="model.id">
          <div>
            {{
              model.product_group_id
                ? model.product_group.name
                : model.product.code
            }}
          </div>
          <div
            class="font-12 text-info"
            style="line-height: 1"
            v-if="model.product_group_id"
          >
            该仪器串下当次绑定的仪器使用记录将被统一修改
          </div>
        </template>
        <ProductGroupSelect
          v-else-if="visible"
          v-model="model.product_group_id"
          :wellid="model.drill_well_id"
          @info="handleInfo"
        ></ProductGroupSelect>
      </el-form-item>
      <el-form-item label="使用日期" prop="used_date">
        <el-date-picker
          :picker-options="{
            disabledDate(time) {
              return time.getTime() > Date.now()
            },
          }"
          v-model="model.used_date"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="趟钻数" prop="usage">
        <el-select v-model="model.usage">
          <el-option v-for="i in 100" :key="i" :value="i" :label="`第${i}趟`"
            >第{{ i }}趟</el-option
          >
        </el-select>
      </el-form-item>
      <el-form-item label="入井时间" prop="down_well_time">
        <el-date-picker
          :picker-options="{
            disabledDate(time) {
              return time.getTime() > Date.now()
            },
          }"
          v-model="model.down_well_time"
          type="datetime"
          format="yyyy-MM-dd HH"
          value-format="yyyy-MM-dd HH"
          popper-class="datetime-hour"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="出井时间" prop="up_well_time">
        <el-date-picker
          :picker-options="{
            disabledDate(time) {
              return time.getTime() > Date.now()
            },
          }"
          v-model="model.up_well_time"
          type="datetime"
          format="yyyy-MM-dd HH"
          value-format="yyyy-MM-dd HH"
          popper-class="datetime-hour"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="工作时长" prop="used_hour">
        <el-input-number v-model="model.used_hour"></el-input-number>
      </el-form-item>
      <template v-if="!model.id">
        <el-form-item
          label="井号"
          prop="drill_well_id"
          v-if="model.add_type == 3"
        >
          <DrillWellSelect
            v-model="model.drill_well_id"
            @info="model.used_extra = getRecordExtrainfo($event)"
          ></DrillWellSelect>
        </el-form-item>
        <el-form-item
          v-else
          :label="param.label"
          v-for="param in model.used_extra"
          :key="param.key"
        >
          <el-input v-model="param.value"></el-input>
        </el-form-item>
        <el-form-item label="起钻原因" prop="up_reason">
          <el-input v-model="model.up_reason" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="故障描述" prop="malfunction">
          <el-input v-model="model.malfunction" type="textarea"></el-input>
          <div class="font-12" style="line-height: 1.5em; margin-top: 5px">
            注：如果无故障请输入
            <span class="pointer" @click="model.malfunction = '/'">
              <span class="text-info">"/"</span>（或点此输入）。</span
            >
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="model.remark" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="图片" class="long">
          <el-upload
            class="upload-small"
            multiple
            :action="actionUrl"
            :headers="uploadHeader"
            :on-error="handleUploadError"
            :on-remove="handleOnRemove"
            :on-success="handleOnSuccess"
            list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频" class="long">
          <VideoUploader v-model="model.videos" v-if="visible"></VideoUploader>
        </el-form-item>
        <!-- <el-form-item label="仪器备注" class="long">
          <div
            style="display: flex; gap: 5px; margin-bottom: 5px"
            v-for="(param, index) in model.remarks"
            :key="index"
          >
            <ProductSelect
              v-model="param.product_id"
              :productGroupId="model.product_group_id || -1"
              style="width: auto"
            ></ProductSelect>
            <el-input v-model="param.remark" placeholder="仪器备注"></el-input>
            <el-button class="ml-10" @click="model.remarks.splice(index, 1)"
              >删除</el-button
            >
          </div>
          <el-button
            size="mini"
            type="primary"
            @click="
              model.remarks.push({
                product_id: '',
                remark: '',
              })
            "
            >添加</el-button
          >
        </el-form-item> -->
      </template>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { productBatchDisassemble } from '@/service/getData'
import { urlPerfix } from '@/config/env'
import store from '@/store/index'
import ProductGroupSelect from '../../components/select/ProductGroupSelect.vue'
import { calculateHoursDifference } from '../../util'
import { productRecordUpdate } from '../../service/getData'

export default {
  components: {
    ProductGroupSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    'model.down_well_time': 'updateUsedHour',
    'model.up_well_time': 'updateUsedHour',
  },
  data() {
    return {
      actionUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      visible: this.show,
      submiting: false,
      rules: {
        product_group_id: [
          { required: true, message: '请选择仪器串', trigger: 'change' },
        ],
        usage: [{ required: true, message: '请选择趟钻数', trigger: 'change' }],
        used_date: [
          { required: true, message: '请选择使用日期', trigger: 'change' },
        ],
        down_well_time: [
          { required: true, message: '请选择入井时间', trigger: 'change' },
        ],
        up_well_time: [
          { required: true, message: '请选择出井时间', trigger: 'change' },
        ],
        used_hour: [
          { required: true, message: '工作时长不能为空', trigger: 'change' },
          {
            type: 'number',
            min: 1,
            max: 100000,
            message: '工作时长不能为0',
            trigger: 'blur',
          },
        ],
        up_reason: [
          { required: true, message: '请填写起钻原因', trigger: 'change' },
        ],
        malfunction: [
          { required: true, message: '请填写故障描述', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      if (this.submiting) return
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let res
          if (this.model.id) {
            res = await productRecordUpdate(this.model)
          } else {
            res = await productBatchDisassemble(this.model)
          }
          if (res.status == 0) {
            this.$emit('created', res.data)
            this.visible = false
          }
          this.submiting = false
        }
      })
    },
    handleInfo(info) {
      return
      if (info) {
        const keys = ['usage', 'used_hour', 'up_reason', 'malfunction']
        keys.map((k) => {
          this.model[k] = info[k]
        })
      }
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    handleOnRemove(file) {
      let index = this.model.imgs.indexOf(file.response.data)
      this.model.imgs.splice(index, 1)
    },
    handleOnSuccess(res, file) {
      this.model.imgs.push(res.data)
    },
    updateUsedHour() {
      let h = calculateHoursDifference(
        this.model.down_well_time,
        this.model.up_well_time,
      )
      this.model.used_hour = h
    },
  },
}
</script>


<style>
.datetime-hour .el-time-spinner .el-scrollbar {
  width: 100%;
}
.datetime-hour .el-time-spinner .el-scrollbar:nth-child(2) {
  display: none;
}

.datetime-hour .el-time-panel__footer {
  display: none;
}

.datetime-hour
  .el-date-picker__time-header
  .el-date-picker__editor-wrap:nth-last-child(1)
  .el-input__inner {
  text-align: center;
}
</style>